import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm, useWatch } from "react-hook-form";
import Breadcrumb from '../../../components/layout/Breadcrumb';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function FinalClearance() {
    const navigate = useNavigate();
    const location = useLocation();
    const { register, handleSubmit, onSubmit, reset, formState: { errors }, control, getValues } = useForm();
    const [formKey, setFormKey] = useState(0);

    const finalChecklist = ["Leaves", "Reimbursement", "Claim", " Insurance/benefits canceled or transferred", "Access to internal tools revoked"]

    // for post btn conditionally disabled
    const checkboxValues = useWatch({
        control,
        name: finalChecklist.map(item => `finalCheckboxApprovalForClearance.${item}`),
    });

    const hasErrors = Object.keys(errors).length > 0;
    const allChecked = checkboxValues?.every(val => val === true);
    const isProceedFinalChecklistDisabled = !allChecked || hasErrors;

    const handleFormSubmit = async (data) => {
        if (Object.keys(errors).length > 0) {
            return;
        }
        onSubmit(data);
        reset({
            finalCheckboxApprovalForClearance: finalChecklist.reduce((acc, item) => {
                acc[item] = false;
                return acc;
            }, {})
        });
        setTimeout(() => {
            navigate('/admin/offboarded/report', {
                state: {
                    breadcrumbTrail: [
                        ...(location.state?.breadcrumbTrail || []),
                        { name: 'Report', path: '/admin/offboarded/report' }
                    ]
                }
            });
        }, 2000);
        toast.success("Final Clearance Checklist submitted successfully!");
    };

    const handleCancelFinalChecklist = () => {
        const { finalCheckboxApprovalForClearance = {} } = getValues();
        const isFormEmpty = Object.values(finalCheckboxApprovalForClearance).every(val => !val);

        if (isFormEmpty) {
            navigate('/admin/offboarded/checklist');
        } else {
            reset();
            setFormKey(prev => prev + 1);
        }
    };

    return (
        <div className='container-fluid'>
            <div className='row clearfix'>
                <div className='col-md-12'>
                    <Breadcrumb />
                    <div className='attendance-container' style={{ padding: '0', marginBottom: '45px', marginTop: '34px' }}>
                        <form key={formKey} onSubmit={handleSubmit(handleFormSubmit)}>
                            <h4 className='apply-leave-heading'>Final Clearance Checklist</h4>
                            <p style={{ marginTop: '-13px' }}>Please review and confirm each item to proceed with your final clearance</p>
                            <div className='apply-leave-section' style={{ marginBottom: '15px' }}>
                                <div className="input-text">
                                    <div className="user-input-icons">
                                        {finalChecklist.map((item) => (
                                            <div key={item.id} style={{ marginBottom: '8px' }}>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        {...register(`finalCheckboxApprovalForClearance.${item}`)} />
                                                    {item}
                                                </label>
                                            </div>
                                        ))}
                                        <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                            <button className="primary-btn" type='button' style={{ background: 'darkgray', width: '100px' }} onClick={() => handleCancelFinalChecklist()}>Cancel</button>
                                            <button className="primary-btn" type="submit" style={{ width: '100px' }}
                                                disabled={isProceedFinalChecklistDisabled}
                                            >Next</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div >
    )
}
